import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "6월",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "7월",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "8월",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "9월",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "10월",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "11월",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "12월",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default class Example extends PureComponent {
  static demoUrl = "https://codesandbox.io/s/synchronized-line-charts-zc3nl";

  render() {
    return (
      <div style={{ width: "100%" }}>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={250}
            data={data}
            syncId="anyId"
            margin={{
              top: 60,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="pv"
              stroke="#82ca9d"
              fill="#82ca9d"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
